export default (visibility) => ({visibility});
